export default "__VITE_ASSET__CKjckmq$__"